/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import PageLayout from "LayoutContainers/PageLayout";
import Logo from "assets/images/logo_full.png";

function CoverLayout({ color, header, title, description, image, top, children }) {
  return (
    <PageLayout background="white" sx={{ className: "login-bg" }}>
      <Grid
        container
        justifyContent="center"
        sx={{
          minHeight: "75vh",
          margin: 0,
        }}
      >
        <Grid item xs={11} sm={8} md={5} xl={3}>
          <SoftBox mt={top} className="login-form">
            <SoftBox pt={3} px={3}>
              {!header ? (
                <>
                  <div className="" style={{ width: "100%" }}>
                    <a href="/" style={{ outline: "none", border: 0, borderStyle: "none" }}>
                      <div style={{ textAlign: "right" }}>
                        <SoftBox component="img" src={Logo} alt={""} width="8rem" />
                      </div>
                      <div>
                        <SoftBox
                          sx={{
                            fontSize: "0.6em",
                            textAlign: "right",
                            marginRight: "10px",
                            transform: "translate(2%,-30%)",
                          }}
                        >
                          <SoftTypography variant="text" fontWeight="bold">
                            Backoffice
                          </SoftTypography>
                        </SoftBox>
                      </div>
                    </a>
                  </div>
                  <SoftBox mb={1}>
                    <SoftTypography variant="h3" fontWeight="bold" color={color} textGradient>
                      {title}
                    </SoftTypography>
                  </SoftBox>
                  <SoftTypography variant="body2" fontWeight="regular" color="text">
                    {description}
                  </SoftTypography>
                </>
              ) : (
                header
              )}
            </SoftBox>
            <SoftBox p={3}>{children}</SoftBox>
          </SoftBox>
        </Grid>
        <Grid item xs={12} md={5}>
          <SoftBox
            height="100%"
            display={{ xs: "none", md: "block" }}
            position="relative"
            right={{ md: "-12rem", xl: "-16rem" }}
            mr={-16}
            sx={{
              transform: "skewX(-10deg)",
              overflow: "hidden",
              borderBottomLeftRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
            }}
          >
            <SoftBox
              ml={-8}
              height="100%"
              marginLeft="-45%"
              sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                transform: "skewX(10deg)",
              }}
            />
          </SoftBox>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="right"
        sx={{
          minHeight: "20px",
          margin: 0,
        }}
      >
        <SoftBox sx={{ position: "absolute", bottom: "0px", minHeight: "20px" }}>
          <SoftTypography sx={{ fontSize: "0.7rem", color: "#ffffff75" }}>
            © FeedTheBet. All Rights Reserved.
          </SoftTypography>
        </SoftBox>
      </Grid>
    </PageLayout>
  );
}

// Setting default values for the props of CoverLayout
CoverLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
  top: 20,
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
